import { bus_xe } from '../../models/response/bus/bus_xe';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_XE_PATH = "bus/xe";

class BusXeApi extends BaseCRUDApi<bus_xe> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/bus/xe`);
	}
}
export const busXeApi = new BusXeApi(API_BUS_XE_PATH);
